import { forwardRef, RefObject } from 'react';

// Utils
import { combineClasses } from '@shared/utils';

// Types
import { Project } from '@shared/types';

// Components
import { ProjectMentionItem } from './ProjectMentionItem';
interface ProjectMentionDropdownProps {
  projects: Project[];
  isLoading: boolean;
  selectedIndex: number;
  selectedProjectRef: RefObject<HTMLButtonElement | null>;
  isVisible: boolean;
  onProjectSelect: (project: Project) => void;
}
export const ProjectMentionDropdown = forwardRef<HTMLDivElement, ProjectMentionDropdownProps>(({
  projects,
  isLoading,
  selectedIndex,
  selectedProjectRef,
  isVisible,
  onProjectSelect
}, ref) => {
  if (!isVisible) return null;
  return <div ref={ref} className={combineClasses('absolute top-full bottom-auto md:bottom-full md:top-auto my-2 left-0 right-0', 'bg-white border border-border-500 rounded-lg shadow-lg', 'max-h-60 overflow-y-auto z-[100] small-scrollbar')} id="project-mention-dropdown" data-testid="project-mention-dropdown" role="listbox" aria-label="Project mention suggestions" aria-live="polite" aria-expanded={isVisible}>
        {isLoading ? <div className="py-2 px-3 h-12" data-testid="project-mention-loading">
            <div className="h-full flex-center gap-3.5 animate-pulse">
              <div className="size-7.5 bg-gray-200 rounded-sm" />
              <div className="h-6 bg-gray-200 rounded flex-1" />
            </div>
          </div> : projects.length > 0 ? projects.map((project, index) => {
      const {
        id = ''
      } = project.projectInfo || {};
      return <ProjectMentionItem key={id || index} project={project} index={index} isSelected={index === selectedIndex} selectedProjectRef={selectedProjectRef} onProjectSelect={onProjectSelect} />;
    }) : <div data-testid="project-mention-empty" role="status" aria-live="polite" className="p-3 text-center text-gray-500 text-sm">
            No matching projects found
          </div>}
      </div>;
});